<template>
  <navbar
    position="fixed"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <nav-link
          class="nav-link"
          to="/home"
        >
          Home
        </nav-link>
      </li>
      <li class="nav-item">
        <nav-link
          class="nav-link"
          href="https://www.123db.at"
          @click.prevent="redirect"
        >
          123db - Unternehmenssoftware im Baukastenprinzip
        </nav-link>
      </li>
      <li class="nav-item">
        <nav-link
            class="nav-link btn btn-primary"
            to="/contact"
        >
          <p>Jetzt Erstgespräch vereinbaren</p>
        </nav-link>
      </li>
    </template>
  </navbar>
</template>

<script>
  import { DropDown, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'MainNavbar',
    components: {
      DropDown,
      Navbar,
      NavLink,
      [Popover.name]: Popover
    },
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    data() {
      return {
        redirecting: false
      }
    },
    methods: {
      async redirect() {
        const espoClient = this.useEspoClient();

        try {
          this.redirecting = true;
          const response = await espoClient.get('redirect/123db');
          this.redirecting = false;
          
          if (response?.url) {
            window.open(response.url, '_blank');
          }
        } 
        catch {
          // Fail silently.
        }
        finally {
          this.redirecting = false;
        }
      }
    }
  }
</script>

<style scoped>

</style>
